import { render, staticRenderFns } from "./MessageTextarea.vue?vue&type=template&id=a70805d2&scoped=true&"
import script from "./MessageTextarea.vue?vue&type=script&lang=js&"
export * from "./MessageTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MessageTextarea.vue?vue&type=style&index=0&id=a70805d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70805d2",
  null
  
)

export default component.exports